import { render, staticRenderFns } from "./CbsDbConnections.vue?vue&type=template&id=f62c80be"
import script from "./CbsDbConnections.vue?vue&type=script&lang=js"
export * from "./CbsDbConnections.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports